import { createArrayComputedMap } from '@/utils/diffHelpers'
import { createLegacyMap } from '@/utils/programData'

import type { CreateMapFn } from '@/stores/programData'

export const createMap: CreateMapFn = () => {
  return {
    ...createLegacyMap(),
    ...createArrayComputedMap('storeLocations', 'applicantOperations.q5', 'response', {
      shoppingMall: 'Shopping Mall',
      standaloneStore: 'Standalone Store',
      stripCenter: 'Strip Center',
    }),
  }
}
